import type { Event } from '@ori-events/open-back-in-stock-notification-dialog';
import { Name } from '@ori-events/open-back-in-stock-notification-dialog';
import { DialogBase } from '@ori-ui/components';
import React, { useCallback, useEffect, useState } from 'react';

import { useAppContext } from '../../contexts';
import { NotifyCumulus } from '../NotifyCumulus/NotifyCumulus';
import { NotifyNonCumulus } from '../NotifyNonCumulus/NotifyNonCumulus';

export const NotifyPopup: React.FC = () => {
    const { notifyMeSubscriptionConfiguration } = useAppContext();
    const [productCode, setProductCode] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const closeDialog = useCallback(() => {
        setIsDialogOpen(false);
    }, []);
    const element = notifyMeSubscriptionConfiguration.IsCumulusMarket ? (
        <NotifyCumulus productCode={productCode} />
    ) : (
        <NotifyNonCumulus productCode={productCode} />
    );

    useEffect(() => {
        const openDialog = (event: Event): void => {
            const { code } = event.detail;

            setIsDialogOpen(true);
            setProductCode(code);
        };

        window.addEventListener(Name, openDialog as EventListener);

        return () => window.removeEventListener(Name, openDialog as EventListener);
    }, []);

    return (
        <DialogBase open={isDialogOpen} onClose={closeDialog}>
            {element}
        </DialogBase>
    );
};
